import { createGlobalStyle } from 'styled-components';
export var GlobalStyle = createGlobalStyle(["#", " *{font-family:Avenir;letter-spacing:normal;font-stretch:normal;font-style:normal;}#", " .adyen-checkout__wrapper{& input{padding-bottom:2px;}& >div{pointer-events:none;}}#", " .adyen-checkout__payment-method{}#", " input{color:#36424a;font-weight:900;::placeholder{color:#6e7a83;}}#", " .adyen-checkout__date{&::-webkit-calendar-picker-indicator{margin-right:30px;margin-bottom:4px;cursor:pointer;}-webkit-appearance:none;}#", " .adyen-checkout__empty-date{color:#B4BBBE;font-weight:100;&::-webkit-calendar-picker-indicator{margin-right:7px;}}#", " .adyen-checkout__input-pointer{cursor:pointer;}#", " .adyen-checkout__input-mobile{&::-webkit-date-and-time-value{text-align:left;}&.adyen-checkout__date{padding-top:11px;}&.adyen-checkout__empty-date{&::before{color:#6e7a83;content:\"dd / mm / aaaa\";}}&.adyen-checkout__empty-date{&::before{color:#6e7a83;content:\"dd / mm / aaaa\";}}&.adyen-checkout__empty-date__android{&::-webkit-date-and-time-value{height:0;}}}#", " .adyen-checkout__dropin{padding-top:12px;padding-bottom:12px;}#", " .adyen-checkout__payment-method__header,#", " .adyen-checkout__payment-method__details{}#", " .adyen-checkout__label__text{display:none;}#", " .adyen-checkout__wrapper input{background-color:#fff;color:#36424a;border:1px solid #b9c4c9;border-radius:6px;padding:5px 8px;height:40px;position:relative;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;width:100%;&.adyen-checkout__input--disabled{background-color:#e6e9eb;border:1px solid #e6e9eb;cursor:default;}}"], function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
}, function (p) {
  return p.namespace;
});